import Vue from 'vue'

const store = Vue.observable({
    tariffs: [],
    discountActivations: [],
    provinces: [],
    regions: [],
    regionsByCode: {},
    provincesByRegionCode: {},
    provincesTree: [],
});

export default store

export function init({tariffs, discountActivations, provinces, parentProfile}) {

    store.tariffs = tariffs
    store.discountActivations = discountActivations
    store.provinces = provinces
    store.parentProfile = parentProfile

    store.regionsByCode = store.provinces.reduce((acc, p) => {
        acc[p.region_code] = p.region_name
        return acc
    }, {})

    store.regions = Object.keys(store.regionsByCode)
        .map(code => ({
            region_code: code,
            region_name: store.regionsByCode[code]
        }))
        .sort((a, b) => a.region_name.localeCompare(b.region_name))

    store.provincesByRegionCode = store.provinces.reduce((acc, p) => {
        if (!acc[p.region_code]) {
            acc[p.region_code] = []
        }
        acc[p.region_code].push(p)
        return acc
    }, {})

    store.provincesTree = Object.keys(store.provincesByRegionCode).map(region_code => {
        return {
            id: region_code,
            text: store.regionsByCode[region_code],
            is_region: true,
            children: store.provincesByRegionCode[region_code].map(p => ({
                id: p.belong_to,
                text: p.belong_to,
                is_region: false,
            }))
        }
    })

    store.products = store.tariffs
        .reduce((acc, i) => {
            const foundIndex = acc.findIndex(p => p.codice === i.codice);
            if (foundIndex !== -1) {
                acc[foundIndex] = i;  // Replace the existing item with the new one
            } else {
                acc.push(i);  // Add new item to the accumulator
            }
            return acc;
        }, [])
        .map(i => ({value: i.codice, text: i.descrizione}))
        .map(product => {
            product.warranties = store.tariffs
                .filter(p => p.codice === product.value)
                .reduce((acc, p) => {
                    acc.push(...p.warranties)
                    return acc
                }, [])
                .reduce((acc, w) => {
                    if (acc.some(i => i.codice === w.codice)) {
                        return acc
                    }
                    acc.push(w)
                    return acc
                }, [])
                .map(w => ({value: w.codice, text: w.descrizione}));
            return product
        })

}
